import { useMemo, useState } from 'react';
import { Card, CardBody, CardHeader, Row, Col, Button, Label, Input, FormGroup, Modal, ModalHeader, ModalBody } from 'reactstrap';
import moment from 'moment';
import { Api } from '../../../componentes/Api';

const InformesVentas = () => {
    const [fechaInicio, setFechaInicio] = useState(new Date());
    const [fechaFin, setFechaFin] = useState(new Date());
    const [tipoFactura, setTipoFactura] = useState('TODOS');
    const [verHistorial, setVerHistorial] = useState(false);
    const [reporteApi, setReporteApi] = useState('');

    const fi = useMemo(() => moment(fechaInicio).format('YYYY-MM-DD'), [fechaInicio]);
    const ff = useMemo(() => moment(fechaFin).format('YYYY-MM-DD'), [fechaFin]);

    const abrirHistorialVentas = () => {
        const apiReporte = `${Api}VentasTrans/HistorialFactura/fecha/${fi}/${ff}`;
        setReporteApi(apiReporte);
        setVerHistorial(true);
    };

    const abrirCuadreCajaPV = () => {
        window.open('/CuadreCajaPV', '_blank');
    };

    const abrirCuadreCajaNCF = () => {
        window.open('/CuadreCajaNCF', '_blank');
    };

    return (
        <>
            <Card>
                <CardHeader style={{ backgroundColor: '#4e73df', color: 'white' }}>
                    Informes de Ventas
                </CardHeader>
                <CardBody>
                    <Row>
                        <Col md={3}>
                            <FormGroup>
                                <Label>Desde</Label>
                                <Input
                                    type="date"
                                    value={fi}
                                    onChange={(e) => setFechaInicio(e.target.value)}
                                />
                            </FormGroup>
                        </Col>
                        <Col md={3}>
                            <FormGroup>
                                <Label>Hasta</Label>
                                <Input
                                    type="date"
                                    value={ff}
                                    onChange={(e) => setFechaFin(e.target.value)}
                                />
                            </FormGroup>
                        </Col>
                        <Col md={3}>
                            <FormGroup>
                                <Label>Tipo Factura</Label>
                                <Input
                                    type="select"
                                    value={tipoFactura}
                                    onChange={(e) => setTipoFactura(e.target.value)}
                                >
                                    <option value="TODOS">Todos</option>
                                    <option value="FACTURA">Factura</option>
                                    <option value="COTIZACION">Cotizacion</option>
                                    <option value="CREDITO">Credito</option>
                                    <option value="CONTADO">Contado</option>
                                </Input>
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col md={4} className="mb-2">
                            <Button color="primary" block onClick={abrirHistorialVentas}>
                                <i className="fas fa-print" /> Historial de Ventas
                            </Button>
                        </Col>
                        <Col md={4} className="mb-2">
                            <Button color="success" block onClick={abrirCuadreCajaPV}>
                                <i className="fas fa-cash-register" /> Cuadre Caja Punto Venta
                            </Button>
                        </Col>
                        <Col md={4} className="mb-2">
                            <Button color="info" block onClick={abrirCuadreCajaNCF}>
                                <i className="fas fa-file-invoice" /> Cuadre Caja NCF
                            </Button>
                        </Col>
                    </Row>
                </CardBody>
            </Card>

            <Modal isOpen={verHistorial} toggle={() => setVerHistorial(false)} size="xl" className="modal-preguntas">
                <ModalHeader toggle={() => setVerHistorial(false)} className="modal-header1">
                    Historial de Ventas
                </ModalHeader>
                <ModalBody>
                    <iframe
                        src={`/Informes/Facturacion/ListaFacturas.html?API=${encodeURIComponent(reporteApi)}&TIPOFACTURA=${encodeURIComponent(tipoFactura)}&ORIGEN=CuadreCajaNCF`}
                        title="Historial de Ventas"
                        style={{ width: '100%', height: '78vh', border: 'none' }}
                    />
                </ModalBody>
            </Modal>
        </>
    );
};

export default InformesVentas;
